import AlertDialog from "@/src/components/atom/AlertDialog";
import { useTranslation } from "react-i18next";

interface DeleteShipmentAlertDialogProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  onOk: () => void;
}

function DeleteShipmentAlertDialog({
  open,
  onOpenChange,
  onOk,
}: DeleteShipmentAlertDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog
      open={open}
      title={t("shipment:exporter.detail.alert.deleteShipmentTitle")}
      onOpenChange={onOpenChange}
      onOk={onOk}
      okText={t("common:delete")}
      cancelText={t("shipment:exporter.detail.button.cancelButton")}
      type="delete"
    >
      {t("shipment:exporter.detail.alert.deleteShipmentDescription")}
    </AlertDialog>
  );
}

export default DeleteShipmentAlertDialog;
